import styled, { css } from 'styled-components';
import { TextStyle } from 'components/text';

const Main_disabled = css`
  background-color: ${({ theme }) => theme.neutral_200};
  box-shadow: inset 1px 3px 12px -4px ${({ theme }) => theme.neutral_300};
`;

export const Main = styled.label<{
  $disabled?: boolean;
  $isLate?: boolean;
  $isCheckboxHidden?: boolean;
}>`
  width: ${({ $isCheckboxHidden }) => ($isCheckboxHidden ? '286px' : 'auto')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 16px;
  gap: 8px;
  cursor: ${({ $isCheckboxHidden }) =>
    $isCheckboxHidden ? 'auto' : 'pointer'};
  border: 1px solid transparent;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.neutral_100};

  ${({ $disabled }) => $disabled && Main_disabled}

  ${({ $isLate, theme }) =>
    $isLate &&
    css`
      border-color: ${theme.danger_300};
    `}


  ${({ $isCheckboxHidden, theme }) =>
    $isCheckboxHidden &&
    css`
      border-color: ${theme.neutral_300};
    `}

  ${TextStyle} {
    overflow: hidden;
    text-overflow: ellipsis;
    align-self: flex-start;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const TitleWrapper = styled.div<{ $isLate?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;

  ${({ $isLate, theme }) =>
    $isLate &&
    css`
      color: ${theme.danger_300};
    `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CreatedDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  &:before {
    content: '';
    height: 1px;
    width: 100%;
    background-color: ${({ theme }) => theme.neutral_300};
  }
`;

export const DetailsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .link-text {
    padding: 2px;
    text-decoration: underline;
    color: ${({ theme }) => theme.primary_300};
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }

  .late-collect {
    color: ${({ theme }) => theme.danger_300};
  }
`;
